<template>
    <div class="tab-pane fade show active">
        <div class="nav-tabs-wrap">
            <ul class="nav nav-tabs" role="tablist">
                <li v-for="inning in global.Components['MatchDetail'].match.innings" :key="inning.order" role="tab">
                    <a href="javascript:;" :class="{ 'active': inningNumber == inning.order }" @click.prevent="changeInningTo(inning.order)">
                       {{ inning.caption }}
                </a>
            </li>
        </ul>
        <div class="dropdown sort-dropdown">
            <span class="dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" href="javascript:;"
               >Sort by <i class="ico-down-arrow"></i
                ></span>
            <div class="dropdown-menu">
                <button type="button" class="dropdown-item" :class="{all: sortBy == 'Four'}" @click="sortBy = 'Four'">Fours</button>
                <button type="button" class="dropdown-item" :class="{all: sortBy == 'Six'}" @click="sortBy = 'Six'">Sixes</button>
                <button type="button" class="dropdown-item" :class="{all: sortBy == 'Wicket'}" @click="sortBy = 'Wicket'">Wickets</button>
                <button type="button" class="dropdown-item" :class="{all: sortBy == ''}" @click="sortBy = ''">All Moments</button>
            </div>
        </div>
    </div>

    <div class="tab-content text-center" v-if="! is_data_ready">
        <span class="loader"></span>
    </div>
    <div class="tab-content text-center" v-else-if="commentaries.length == 0">
        <p>No commentary data found.</p>
    </div>
    <div class="tab-content" v-else>
        <div class="tab-pane fade show active">
            <div
                class="commentary-box"
                v-for="over in Object.keys(commentaries).sort((a, b) => b - a)"
                :key="over"
                >
                <div class="commentary-box-head">
                    <div class="box-head-left">
                        <strong>Over {{ over }}</strong>
                    </div>
                    <div class="box-head-right" v-if="sortBy == ''">
                        <span class="d-none d-md-block">
                            {{ commentaries[over].bowler }} {{ commentaries[over].runs }} Runs, {{ commentaries[over].wickets }} Wickets
                        </span>
                        <span class="d-md-none">
                            {{ commentaries[over].bowlerShortname }} {{ commentaries[over].runs }} Runs, {{ commentaries[over].wickets }} Wickets
                        </span>
                    </div>
                </div>
                <div class="commentary-box-body">
                    <ul class="commentary-list">
                        <li v-for="commentary in commentaries[over].commentary" :key="commentary.id">
                            <div class="left-side">
                                <span v-if="commentary.type_id !== 91" class="bowl" :class="(commentary.d_score == 'W')? 'wicket' : ( (commentary.d_score == '4')? 'four' : (commentary.d_score == '6')? 'six' : '')">{{ commentary.d_score }}</span>
                                <span v-if="commentary.type_id !== 91" class="bowl-num">{{ commentary.over }}</span>
                                <i v-else class="ico-chat"></i>
                            </div>
                            <div class="right-side">
                                <strong class="d-none d-md-block" v-if="commentary.player.name && commentary.batsman.name">
                                    {{ commentary.player.name  }} to {{ commentary.batsman.name }}
                                </strong> 
                                <strong class="d-block d-md-none" v-if="commentary.player.name && commentary.batsman.name">
                                    {{ commentary.player.short_name }} to {{ commentary.batsman.short_name}}
                                </strong> 
                                <span class="d-block">{{ commentary.text }}</span>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="text-center">
                <a type="button" v-if="nextPageUrl" @click="loadMore()">Load more</a>
            </div>
        </div>
    </div>
</div>
</template>

<script>
    export default {
        name: 'Commentary',

        components: {},

        data() {
            return {
                commentaries: [],
                inningNumber: 1,
                nextPageUrl: '',
                sortBy: ''
            }
        },
        metaInfo() {
            if (!Components['MatchDetail'])
                return
            let title = Components['MatchDetail'].match.team1.name + " VS " + Components['MatchDetail'].match.team2.name +" Match Commentary " +" - PlanetCricket.com";
            let description = "Commentry - " + Components['MatchDetail'].match.team1.name + " VS " + Components['MatchDetail'].match.team2.name + " - PlanetCricket.com";
            return {
                title: title,
                meta: this.$getMetaTags(title, description),
                link:[
                        {rel: 'canonical', href: 'https://planetcricket.com'+this.$route.path}],
            }

        },
        serverPrefetch() {
            if (this.$store.state.runSsr) {
                this.inningNumber = Components['MatchDetail'].match.innings.length
                return this.getCommentary();
            }
        },
        mounted() {
            this.inningNumber = Components['MatchDetail'].match.innings.length
            this.getCommentary();

            var _this = this;
            this.$root.$on('MatchUpdated', function (data) {
                if (data.match_id == Components['MatchDetail'].match.id) {
                    _this.getCommentary(true);
                }
            });
        },
        beforeDestroy() {
            this.$root.$off('MatchUpdated')
        },

        watch: {
            sortBy() {
                if(isBrowser) 
                this.getCommentary()
            }
        },

        methods: {
            getCommentary(cacheBust = false) {
                return this.$axios
                        .get(this.$MATCH_COMMENTARY_API.replace(':match', this.$route.params.match), {
                            params: {
                                inning: this.inningNumber,
                                sort_by: this.sortBy,
                                per_page: 130,
                                ttl: 0,
                                ...(cacheBust && {cacheBust: Math.ceil(new Date().getTime() / 1000)})
                            }
                        })
                        .then(response => {
                            this.is_data_ready = true
                            this.nextPageUrl = response.data.result.nextPageUrl
                            this.commentaries = response.data.result.commentaries || []
                        })
                        .catch(error => {
                            console.log(error);
                            this.is_data_ready = true
                        })
            },

            changeInningTo(inning) {
                this.inningNumber = inning
                this.nextPageUrl = ''
                this.sortBy = ''
                this.getCommentary()
            },

            loadMore() {
                this.$axios
                        .get(this.nextPageUrl)
                        .then(response => {
                            this.nextPageUrl = response.data.result.nextPageUrl
                            this.commentaries = {...this.commentaries, ...response.data.result.commentaries}
                        })
                        .catch(error => console.log(error))
            }
        }
    }
</script>
